import { GlobalSettings } from "@/model/GlobalSettings";
import { User } from "@/model/User";
import {reactive, ref} from "vue";

export const userLoggedIn = ref(false)
export const userRoles = ref<string[]>([])
export const user = ref<User>(new User("","","",""))
export const globalSettings = ref<GlobalSettings>({creditEnabled: false, sumupEnabled: false})
